export const demoConfig = {
  API: {
    ROOT_URL: () => 'https://apidemoa.econsulttest.health',
    IE_ROOT_URL: () => 'https://demo.webgp.com/corsdemo',
    SUBMISSION_URL: () => 'https://demo.webgp.com/api/consultation/submitsession',
    POSTCODE_URL: (practiceId, postcode) => `https://demo.webgp.com/findMatchingPostcodes/${postcode}`,
    ADDRESSES_URL: (practiceId, postcode) => `https://demo.webgp.com/searchPostcode/${postcode}`,
  },
  S3_BUCKET: `https://s3.eu-west-2.amazonaws.com/test.frontend.econsult.health/econsult-frontend/${process.env.REACT_APP_VERSION}/build`,
  SESSION_TIMEOUT: {
    IN_MINUTES: 20,
  },
  DEV_LOGIN_ENABLED: false,
  PREFILL_ENABLED: true,
  DEMOGRAPHICS_READONLY: true,
  PREFILL_DATA: {
    FIRSTNAME: 'Alex',
    SURNAME: 'Smith',
    PARENT_FIRSTNAME: 'Charlie',
    PARENT_SURNAME: 'Smith',
    TELEPHONE: '02079460999',
    EMAIL: 'someone@webgp.com',
    DATE_OF_BIRTH_ADULT: 'DATE_OF_BIRTH_ADULT',
    DATE_OF_BIRTH_PAED: 'DATE_OF_BIRTH_PAED',
    STRUCTURED_ADDRESS: 'STRUCTURED_ADDRESS',
    ADDRESS: '1 London Road',
    CITY: 'London',
    POSTCODE: 'ID1 1QD',
    NHS_NUMBER: '0123456789',
    PREFERREDGP_NAME: 'Staff Demo Name',
  },
};
